if (!customElements.get('image-with-feature-slider')) {
  customElements.define(
    'image-with-feature-slider',
    class ImageWithFeatureSlider extends HTMLElement {
      constructor() {
        super();
        this.sliderInstance = null;
      }

      connectedCallback() {
        this.swiper = this.querySelector('.swiper');
        if (!this.swiper || typeof window.FoxTheme === 'undefined' || !window.FoxTheme.Carousel) return;

        const paginationEl = this.querySelector('.swiper-pagination');
        const nextEl = this.querySelector('.swiper-button-next');
        const prevEl = this.querySelector('.swiper-button-prev');

        const options = {
          slidesPerView: 1,
          loop: true,
          threshold: 2,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
        };

        if (nextEl && prevEl) {
          options.navigation = {
            nextEl,
            prevEl,
          };
        }

        if (paginationEl) {
          options.pagination = {
            el: paginationEl,
            clickable: true,
          };
        }

        const additionModules = [FoxTheme.Swiper.Autoplay];
        this.sliderInstance = new window.FoxTheme.Carousel(this.swiper, options, additionModules);
        this.sliderInstance.init();
      }
    }
  );
}

